import { connect, RootStateOrAny } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { Alert, Button, Typography } from 'antd';
import { RightOutlined } from '@ant-design/icons';

import { upload } from 'store/claim/batchReports/actions';

import { DropzoneSingle } from 'components/Common/Dropzone';

import './index.scss';

const { Title } = Typography;

// NOTE: Will not work properly without AntiVirusHost Server running in conjunction with backend as of 09/27/21

interface BatchClaimsTestUploadProps {
  upload(uploadObject: Object): any,
  isUploading: boolean,
  fileTypes: string,
  page: string,
  setPage(page: string): void,
  registered: boolean,
};

const BatchClaimsUpload = ({ fileTypes, upload, isUploading, setPage, page, registered }: BatchClaimsTestUploadProps) => {
  const isTestPage = page === 'test';
  
  return(
    <div className="batch-claims-page">
      <div className="header-title">
        <Title level={4}>&nbsp;&nbsp;&nbsp;Batch Claims Test File Upload</Title>
      </div>
      {/* Display Alert based on page type */}
      {isTestPage ? (
        <Alert
          message={"Batch Claim Enrollment:"}
          description={`To submit claims using the online portal, you are first required to register 
          by submitting a test file to create a template for your account. Your test file should include 4-5 sample claims 
          with multiple ICD-10 codes each. Please note that the test file is meant for setting up a template only, and will 
          not be processed as regular claim submission.`}
          type={'info'}
          showIcon
        />
      ) : (
        <Alert
          message={"Module Unavailable:"}
          description={`The Batch Claim module is currently unavailable. Please reach out to 
          support at portal.inquiries@astranahealth.com for assistance.`}
          type={"error"}
          showIcon
        />
      )}

      {/* Conditional button to go to Submit Batch Claims page */}
      {registered && isTestPage && (
        <div className="row" style={{ justifyContent: 'flex-end' }}>
          <Button
            className="mb-2 go-to-button"
            type="primary"
            onClick={() => setPage('files')}
          >
            Go To Submit Batch Claim Files <RightOutlined />
          </Button>
        </div>
      )}
      {isTestPage && (
        <DropzoneSingle
          fileTypes={fileTypes}
          upload={upload}
          isUploading={isUploading}
          page={page}
        />
      )}
    </div>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isUploading: store.rootReducer.claimBatchReports.isUploadingBatchClaimFiles,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
{
  upload,
},
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(BatchClaimsUpload);
